"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeToken = decodeToken;
exports.getTokenExpirationDate = getTokenExpirationDate;
exports.isTokenExpired = isTokenExpired;

// porting code from
// https://github.com/auth0/angular-jwt/blob/master/src/angularJwt/services/jwt.js
function urlBase64Decode(str) {
  var output = str.replace(/-/g, '+').replace(/_/g, '/');

  switch (output.length % 4) {
    case 0:
      {
        break;
      }

    case 2:
      {
        output += '==';
        break;
      }

    case 3:
      {
        output += '=';
        break;
      }

    default:
      {
        throw new Error('Illegal base64url string!');
      }
  } // polyfill https://github.com/davidchambers/Base64.js


  return window.decodeURIComponent(escape(window.atob(output)));
}

function decodeToken(token) {
  var parts = token.split('.');

  if (parts.length !== 3) {
    throw new Error('JWT must have 3 parts');
  }

  var decoded = urlBase64Decode(parts[1]);

  if (!decoded) {
    throw new Error('Cannot decode the token');
  }

  return JSON.parse(decoded);
}

function getTokenExpirationDate(token) {
  try {
    var decoded = decodeToken(token);
    if (typeof decoded.exp === 'undefined') return null; // The 0 here is the key, which sets the date to the epoch

    var d = new Date(0);
    d.setUTCSeconds(decoded.exp);
    return d;
  } catch (e) {
    return null;
  }
}

function isTokenExpired(token) {
  var offsetSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var d = getTokenExpirationDate(token);

  if (d instanceof Date) {
    // Token expired?
    return !(d.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
  }

  return false;
}